import React, { PureComponent } from 'react'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import Radium from 'radium'

class Icon extends PureComponent {
    render() {
        const { className, icon, style } = this.props
        return <div className={className} style={Object.assign({}, styleguide.icons[icon], style)} />
    }
}

export default Radium(Icon)
